<template>
    <div
      class="projectstructure-filter-operator"
      >
        <div 
            class="projectstructure-filter-operator-no-edit"
            v-if="!edit"
            @click="edit = true"
            >
            <TTooltip value="Change operator">
                <TText :text="object.operator" />   
            </TTooltip>
        </div>
        <div v-else class="projectstructure-filter-operator-edit">
            <div class="d-flex">
                <TTooltip value="Add filter brackets">
                    <TIcon 
                        name="area-empty"
                        @click.native="edit=false, $emit('addFilterBracket', {index: obj_index-1, after: true})"
                    />
                </TTooltip>
                <TTooltip value="Add filter line">
                    <TIcon 
                        name="add-circle"
                        @click.native="edit=false, $emit('addFilterLine', {index: obj_index-1})"
                    />
                </TTooltip>
            </div>
            <div 
                class="projectstructure-filter-operator-selector-wrapper"
                v-click-outside="endEdit"
                >
                <TTooltip v-for="operator, index in operators" :key="'operator_'+index" :value="operator.text">
                    <div 
                        class="projectstructure-filter-operator-selector"
                        :style="`${object.operator === operator.value?'background-color: grey;':''}`"
                        @click.prevent.stop="object.operator !== operator.value?$emit('changeOperator'):'', object.operator = operator.value, edit=false"
                    >
                        <TText :color="object.operator === operator.value ? 'primary' : 'not-primary'" :text="operator.value" />   
                    </div>
                </TTooltip>
            </div>
            <div class="d-flex">
                <TTooltip value="Add filter brackets">
                    <TIcon 
                        name="area-empty"
                        @click.native="edit=false, $emit('addFilterBracket', {index: obj_index+1})"
                    />
                </TTooltip>
                <TTooltip value="Add filter line">
                    <TIcon 
                        name="add-circle"
                        @click.native="edit=false, $emit('addFilterLine', {index: obj_index+1, before: true})"
                    />
                </TTooltip>
            </div>
        </div>
    </div>
  </template>
  <script>
    import TIcon from '@/components/Taktify/TIcon.component.vue';
    import TTooltip from '@/components/Taktify/TTooltip.component.vue';
    export default {
      props: ['object', 'obj_index'],
      components: {
        TIcon,
        TTooltip,
      },
      data: () => ({
        edit: false,
        operators: [
            {text: 'And', value: '&&'},
            {text: 'Or', value: '||'},
            {text: 'And not', value: '&&!'},
            {text: 'Or not', value: '||!'},
        ],
      }),
      methods: {
        endEdit() {
            this.edit = false;
        }
      }
    }
  </script>
  <style>
    .projectstructure-filter-operator {
        display: flex;
        width: 100%;
        justify-content: center;
    }
    .projectstructure-filter-operator-no-edit {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border-radius: 6px;
        cursor: pointer;
    }
    /* .projectstructure-filter-operator-no-edit:hover {
        background-color: grey;
    } */
    .projectstructure-filter-operator-edit {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .projectstructure-filter-operator-selector-wrapper {
        display: flex;
        border-radius: 6px;
        background-color: white;
        padding: 3px;
    }
    .projectstructure-filter-operator-selector {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border-radius: 6px;
        color: black;
        cursor: pointer;
    }
  </style>
  